import { useHead } from '@vueuse/head'
import { computed } from 'vue'

import { useTermsAndConditionsStore } from '@/stores/termsAndConditions'

export const fetchTermsAndConditionsStore = async (template: string, slug: string) => {
  const termsAndConditionsStore = useTermsAndConditionsStore()

  await termsAndConditionsStore.fetchTermsAndConditionsData(template, slug)
}

export const useTermsAndConditionsData = () => {
  const companyStore = useTermsAndConditionsStore()
  return computed(() => companyStore.getTermsAndConditionsData)
}

export const useSeo = () => {
  useHead({
    title: useSeoTitle(),
    meta: [
      {
        name: 'description',
        content: useSeoDescription()
      },
      {
        property: 'og:title',
        content: useSeoTitle()
      },
      {
        property: 'og:description',
        content: useSeoDescription()
      }
    ]
  })
}

export const useSeoTitle = () => {
  const termsAndConditionsStore = useTermsAndConditionsStore()
  return computed(() => {
    if (termsAndConditionsStore.getTermsAndConditionsData?.seo_page?.title) {
      return termsAndConditionsStore.getTermsAndConditionsData.seo_page.title
    }
    return null
  })
}

export const useSeoDescription = () => {
  const termsAndConditionsStore = useTermsAndConditionsStore()
  return computed(() => {
    if (termsAndConditionsStore.getTermsAndConditionsData?.seo_page?.[0]?.fields?.description) {
      return termsAndConditionsStore.getTermsAndConditionsData.seo_page[0].fields.description
    }
    return null
  })
}

export const useSeoIndexFollow = (): boolean => {
  const termsAndConditionsStore = useTermsAndConditionsStore()

  return termsAndConditionsStore.getTermsAndConditionsData?.seo_page?.noindexnofollow === true
}
